import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import jaTranslations from '../../messages/ja-JP.json';

/**
 * Japanese (the default and fallback) ships with the app; English is its own
 * chunk, fetched before the first render when it is the active language and
 * otherwise on the first switch.
 */
const lazyLanguages: Record<string, () => Promise<{ default: object }>> = {
  'en-US': () => import('../../messages/en-US.json'),
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'ja-JP': {
        translation: jaTranslations,
      },
    },
    partialBundledLanguages: true,
    fallbackLng: 'ja-JP',
    supportedLngs: ['ja-JP', 'en-US'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
    },
    detection: {
      order: ['cookie', 'localStorage'],
      caches: ['cookie', 'localStorage'],
      lookupCookie: 'NEXT_LOCALE',
      lookupLocalStorage: 'i18nextLng',
    },
  });

/** Load a language's catalog if it is not bundled yet. */
export const ensureLanguage = async (lng: string): Promise<void> => {
  if (i18n.hasResourceBundle(lng, 'translation')) return;
  const load = lazyLanguages[lng];
  if (!load) return;
  const catalog = await load();
  i18n.addResourceBundle(lng, 'translation', catalog.default, true, true);
};

/** Switch the UI language once its catalog is loaded. */
export const changeLanguage = async (lng: string): Promise<void> => {
  await ensureLanguage(lng);
  await i18n.changeLanguage(lng);
};

export default i18n;
